import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-tech bg-white" data-id="element-78" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-79" data-mp="4lqictyan92g" />
      <div className="h-1 bg-alert" aria-hidden="true" data-id="element-80" data-mp="4n1oh0f7oswq" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-81" data-mp="1297ba1bnev89">
        <h1 className="mx-auto max-w-4xl text-center text-2xl leading-display text-navy sm:text-5xl" data-id="element-82" data-mp="xae9351taqne">
          APPRENEZ À LIRE LES ECG{' '}
          <span className="text-tech" data-id="element-83" data-mp="sa9r1al99nv2">
            AVEC UNE MÉTHODE VISUELLE, CLAIRE ET STRUCTURÉE
          </span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-84" data-mp="nbyhl0yvhfdd">
          UN TRACÉ DE 12 DÉRIVATIONS…{' '}
          <span className="text-tech-light" data-id="element-85" data-mp="384jud2bfbpui">MAIS SAVEZ-VOUS VRAIMENT PAR OÙ COMMENCER ?</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-86" data-mp="3j6obhix6kkpk">
          6 modules complémentaires, des tracés annotés, des fiches pratiques et des cas cliniques
          corrigés{' '}
          <strong className="font-semibold text-navy" data-id="element-87" data-mp="3e8wl4tc6p6nh">
            pour progresser étape par étape : FRÉQUENCE › RYTHME › AXE › INTERVALLES › ST-T.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-88" data-mp="358rcygz62489" />

        <div className="mt-2 flex flex-col items-center" data-id="element-89" data-mp="359ja3w8ewa0n">
          <CTAButton href={OFFER_ANCHOR} data-id="element-90" data-mp="2qk3kwkoj4cn2">🫀 OUI ! JE VEUX L’ATLAS COMPLET</CTAButton>
          <TrustLine items={['🛡️ Garantie satisfait ou remboursé de 7 jours', '🫀 Système complet 6 en 1']} data-id="element-91" data-mp="2qi0lja1hl75o" />
        </div>
      </div>
    </section>;
}